<template>
  <div
    v-show="value"
    :style="{
      top: `${top}px`,
      left: `${left}px`
    }"
    class="custom-details-tooltip"
  >
    <!-- HEADER -->
    <div :class="currentStatus.color" class="custom-details-tooltip--header">
      <!-- DATA -->
      <Paragraph v-if="attributes" fontSize="large" fontWeight="medium">{{
        formatDate(attributes.dates[0].start, 'dd MMMM yyyy')
      }}</Paragraph>

      <!-- STATUS -->
      <Paragraph fontSize="large" fontWeight="light">
        <span class="sale">{{ currentStatus.label }}</span>
      </Paragraph>
    </div>

    <!-- BODY -->
    <div class="custom-details-tooltip--body">
      <!-- EDITADO MANUALMENTE -->
      <b-row v-if="attributes && attributes.customData.edited">
        <b-col class="edited-alert">
          <Icon icon="alert" class="edited-alert--icon" />
          <Paragraph fontSize="medium" fontWeight="light"
            >Editado manualmente</Paragraph
          >
        </b-col>
      </b-row>

      <!-- PAX -->
      <b-row class="pax-row ">
        <b-col
          v-for="(pax, i) in paxValues"
          :key="`guests-${pax.label}-${i}`"
          class="pax-col mb-4"
        >
          <label>{{ pax.label }}</label>
          <p v-if="getCurrency" class="value">
            {{ $options.filters[getCurrency](pax.price) }}
          </p>
        </b-col>
      </b-row>

      <!-- COLUNAS MOUSEOVER EM QUARTOS UNICOS -->
      <b-row v-if="attributes">
        <!-- DIREITA -->
        <b-col v-if="attributes.customData.type !== 'resume'">
          <b-row class="mb-2">
            <b-col cols="8"><label>Disponibilidade Let’s Book</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.disponibility }}
              </p></b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col cols="8"><label>Allotment</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.allotment }}
              </p></b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col cols="8"><label>Vendido</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.usedQuantity }}
              </p></b-col
            >
          </b-row>
        </b-col>

        <!-- ESQUERDA -->
        <b-col v-if="attributes.customData.type !== 'resume'">
          <b-row class="mb-2">
            <b-col cols="8"><label>Fechado à Chegada</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.cta ? 'Sim' : 'Não' }}
              </p></b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col cols="8"><label>Fechado à Saída</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.ctd ? 'Sim' : 'Não' }}
              </p></b-col
            >
          </b-row>
          <b-row class="mb-2">
            <b-col
              v-if="attributes && attributes.customData.minNightsType"
              cols="8"
              ><label
                >Min. de noites ({{
                  attributes.customData.minNightsType === 1
                    ? 'chegando em'
                    : 'passando por'
                }})</label
              ></b-col
            >
            <b-col v-else cols="8"><label>Min. de noites</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.minNights }} noites
              </p></b-col
            >
          </b-row>
        </b-col>
      </b-row>

      <!-- COLUNAS DE MOUSEOVER EM TODOS OS QUARTOS -->
      <b-row v-if="attributes">
        <!-- DIREITA -->
        <b-col v-if="attributes.customData.type === 'resume'">
          <b-row class="mb-4">
            <b-col cols="8"><label>Disponibilidade geral</label></b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.disponibility }}
              </p></b-col
            >
          </b-row>
        </b-col>

        <!-- ESQUERDA -->
        <b-col v-if="attributes.customData.type === 'resume'">
          <b-row class="mb-4">
            <b-col class="label-legend" cols="4">Vendido</b-col>
            <b-col cols="4"
              ><p v-if="attributes" class="value">
                {{ attributes.customData.usedQuantity }}
              </p></b-col
            >
          </b-row>
        </b-col>
      </b-row>

      <!-- CATEGORIAS COM RESTRIÇÃO -->
      <b-row v-if="restrictionsValues.length > 0" class="mb-3">
        <b-col class="label-legend" cols="4">
          Categorias com restrição
        </b-col>

        <div class="custom-result">
          <span
            v-for="(data, i) in restrictionsValues"
            :key="`guests-${data.label}-${i}`"
          >
            <span class="value--result">
              <span v-if="restrictionsValues.length - 1 > i">
                {{ data.label }},
              </span>
              <span v-else> {{ data.label }}. </span>
            </span>
          </span>
        </div>
      </b-row>

      <!-- CATEGORIAS COM PRIORIDADE -->
      <b-row v-if="prioritiesValues.length > 0">
        <b-col class="label-legend" cols="4">
          Categorias com prioridade sobre integração
        </b-col>
        <div class="custom-result">
          <span
            v-for="(data, i) in prioritiesValues"
            :key="`guests-${data.label}-${i}`"
          >
            <span class="value--result">
              <span v-if="prioritiesValues.length - 1 > i">
                {{ data.label }},
              </span>
              <span v-else> {{ data.label }}. </span>
            </span>
          </span>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
/**
 * Componente da tooltip de pré-visualização dos dados
 * da data do calendário que está no estado hover
 */
import { mapGetters } from 'vuex'
import { formatDate } from '@/helpers/date'
import Paragraph from '@solucoes/components-lib-tmp/src/components/elements/Paragraph'

export default {
  name: 'DayDetailsTooltip',
  components: {
    Paragraph
  },
  props: {
    /** Posição top do css */
    top: {
      type: Number,
      default: 0
    },
    /** Posição left do css */
    left: {
      type: Number,
      default: 0
    },
    /** Atributos para popular o conteúdo */
    attributes: {
      type: Object,
      default: () => {}
    },
    /** Se está visível */
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      /** Labels e classes para o stauts da tooltip */
      statusLabels: {
        openSales: {
          label: 'Aberto para vendas',
          color: 'green'
        },
        partiallySales: {
          label: 'Fechado parcialmente para vendas',
          color: 'orange'
        },
        closedSales: {
          label: 'Fechado para vendas',
          color: 'red'
        }
      }
    }
  },
  computed: {
    /** Retorna o status atual da diária */
    currentStatus() {
      if (!this.attributes) return false

      const data = this.attributes.customData

      /** Fechado para vendas */
      if (data.closed) return this.statusLabels.closedSales

      let statusItem = this.statusLabels.openSales

      /** Verifica o status do item */
      if (data.status === 1) statusItem = this.statusLabels.closedSales
      if (data.status === 2) statusItem = this.statusLabels.partiallySales
      if (data.status === 3) statusItem = this.statusLabels.openSales

      /** Vendas abertas */
      return statusItem
    },

    /** Retorna informações de restrições no caso de Todos os quartos */
    restrictionsValues() {
      if (!this.attributes?.customData.restricao) return false
      return this.attributes?.customData.restricao.map((item) => {
        return {
          label: `${item}`
        }
      })
    },

    /** Retorna informações de prioridades no caso de Todos os quartos */
    prioritiesValues() {
      if (!this.attributes?.customData.prioridade) return false
      return this.attributes?.customData.prioridade.map((item) => {
        return {
          label: `${item}`
        }
      })
    },

    /** Retorna os valores de Pax da diária */
    paxValues() {
      if (!this.attributes?.customData.paxPrices) return false
      return this.attributes?.customData.paxPrices.map((item) => {
        return {
          label: `${item.tipoPax === 10 ? 'Pax' : 'Cr'} ${item.quantidadePax}`,
          price: item.valor
        }
      })
    },

    ...mapGetters('hotel', ['getCurrency'])
  },
  methods: {
    /** Helper de data */
    formatDate: formatDate
  }
}
</script>

<style lang="scss" scoped>
.custom-details-tooltip {
  min-width: 551px;
  min-height: 249px;
  background-color: $white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  backface-visibility: hidden;
  pointer-events: none;
  will-change: top, left;
  @include box-shadow(0px 10px 25px rgba(0, 0, 0, 0.1));

  &--header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 50px;
    padding: {
      left: 30px;
      right: 30px;
    }
    background-color: $blue;
    color: $white;
    text-transform: capitalize;
  }

  &--body {
    padding: {
      left: 30px;
      right: 30px;
      top: 25px;
      bottom: 25px;
    }

    label,
    .value {
      font-weight: font-weight('weight-medium');
      font-size: font-size('size-small');
      white-space: nowrap;

      &--result {
        font-size: font-size('size-small');
        color: pmw-colors(grey-60);
        line-height: 18px;
      }
    }

    .value {
      font-weight: font-weight('weight-normal');
      color: $gray-dark;
    }
  }

  .edited-alert {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    &--icon {
      width: 14px;
      height: 14px;
      fill: $error;
      margin-right: 5px;
    }
  }

  .sale {
    text-transform: none;

    &__closed {
      &:before {
        background-color: $error;
      }
    }

    &__cta {
      &:before {
        background-color: $orange-2;
      }
    }

    &__ctd {
      &:before {
        background-color: $cyan;
      }
    }
  }

  .pax {
    &-row {
      flex-wrap: nowrap;
    }

    &-col {
      width: 80px;

      label {
        margin-bottom: 10px;
      }
    }
  }
}
.Green,
.green {
  background-color: pmw-colors(success-100);
}
.Red,
.red {
  background-color: pmw-colors(error-100);
}
.Orange,
.orange {
  background-color: pmw-colors(orange-100);
}
.label-legend {
  display: inline-block;
  font-size: pmw-font-size(size-small);
  font-weight: pmw-font-weight(weight-medium);
  line-height: 15px;
}
.custom-result {
  float: right;
  max-width: 310px;
  margin-left: 10px;
}
</style>
